// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PNURH","footer":"styles_footer__14BBS","passCodeTooltip":"styles_passCodeTooltip__2AE9u"};